import { tryParseJSON } from 'app_vodafone_ziggo/util/util';
class ConfigurationManager {
    constructor(configInput) {
        this.configInput = configInput;
        this.shareConfigBtn = document.querySelector('.js-share-configuration-btn');
        this.handleConfigUpdate = this.handleConfigUpdate.bind(this);

        document.addEventListener('teamscalling:configupdate', this.handleConfigUpdate);
    }

    updateShareConfigurationUrl(answers) {
        if (!this.shareConfigBtn) return;

        const shareUrl = new URL(this.shareConfigBtn.getAttribute('text'));
        const shareParams = new URLSearchParams(shareUrl.search);
        shareParams.set('answers', answers);
        shareUrl.search = shareParams.toString();
        this.shareConfigBtn.setAttribute('text', shareUrl.toString());
    }

    /**
     * Get business rules products payload for variation call
     *  output: {"remote-workers":{"qty":1},"vodafone-mobiele-beveiliging":{"qty":1},"service-level-24-7":{"qty":1}}
     * @returns {Object} payload object for businessRulesAddonsInput
     */
    static getBusinessRulesAddons() {
        var businessRulesAddons = {};

        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues) {
            businessRulesAddons = tryParseJSON(addToCartValues.dataset.businessRulesAddons, {});
        }

        return businessRulesAddons;
    }

    /**
     * convert input value to variation call payload structure
     * @returns {Object} payload object for addons
     */
    static getAddons() {
        var addons = [];
        var addonsQty = [];

        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues) {
            addons = tryParseJSON(addToCartValues.dataset.addons, []);
            addonsQty = tryParseJSON(addToCartValues.dataset.addonsQty, []);
            addons = addons.map((addon) => addon.split('_')[0]);
        }

        return { addons, addonsQty };
    }

    /**
     * Remove or update item from addons & addonsQty array or businessRulesAddons array
     * @param {string} pid - product id
     * @param {string} qty - product qty
     * @param {Array} addons - array of addon ids
     * @param {Array} addonsQty - array of addon quantities
     * @param {Object} businessRulesAddons - object of business rules addons
     * @returns {Object} updated addons, addonsQty and businessRulesAddons
     */
    static updateItemInAddons(pid, qty, addons, addonsQty, businessRulesAddons) {
        const addonIdToUpdate = pid.split('_')[0];
        const index = addons.indexOf(addonIdToUpdate);
        if (index > -1) {
            if (qty > 0) {
                addonsQty[index] = qty;
            } else {
                addons.splice(index, 1);
                addonsQty.splice(index, 1);
            }
        } else if (pid in businessRulesAddons) {
            if (qty > 0) {
                businessRulesAddons[pid].qty = qty;
            } else {
                delete businessRulesAddons[pid];
            }
        }

        return { addons, addonsQty, businessRulesAddons };
    }

    /**
     * remove item from addons & addonsQty array or businessRulesAddons array
     * @param {string} pid - product id
     * @param {Array} addons - array of addon ids
     * @param {Array} addonsQty - array of addon quantities
     * @param {Object} businessRulesAddons - object of business rules addons
     * @returns {Object} updated addons, addonsQty and businessRulesAddons
     */
    static removeItemFromAddons(pid, addons, addonsQty, businessRulesAddons) {
        const addonIdToRemove = pid.split('_')[0];
        const index = addons.indexOf(addonIdToRemove);
        if (index > -1) {
            addons.splice(index, 1);
            addonsQty.splice(index, 1);
        } else if (pid in businessRulesAddons) {
            delete businessRulesAddons[pid];
        }

        return { addons, addonsQty, businessRulesAddons };
    }

    static setAddonDataAttributes(businessRulesAddons, addons, addonsQty) {
        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues) {
            addToCartValues.dataset.businessRulesAddons = JSON.stringify(businessRulesAddons);
            addToCartValues.dataset.addons = JSON.stringify(addons);
            addToCartValues.dataset.addonsQty = JSON.stringify(addonsQty);
        }
    }

    static setPidAttribute(pid) {
        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues && pid) {
            addToCartValues.dataset.pid = pid;
        }
    }

    static setActiveConfigAttribute(activeConfiguration) {
        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues && activeConfiguration) {
            addToCartValues.dataset.activeConfiguration = activeConfiguration;
        }
    }

    /**
     * sets linesqty attribute on js-add-to-cart-values div
     * @param {number} qty - quantity of users
     */
    static setLinesQtyAttribute(qty) {
        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues && qty) {
            addToCartValues.dataset.linesqty = qty;
        }
    }

    /**
     * sets usersqty attribute on js-add-to-cart-values div
     * @param {number} qty - quantity of users
     */
    static setUsersQtyAttribute(qty) {
        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues && qty) {
            addToCartValues.dataset.usersqty = qty;
        }
    }

    /**
     * Parse configuration from input, handling errors gracefully
     * @returns {Object} The parsed configuration object
     */
    parseConfig() {
        try {
            return this.configInput.value ? JSON.parse(this.configInput.value) : {};
        } catch (e) {
            return {};
        }
    }

    /**
     * Remove sub questions and their addons when parent question changes
     * @param {Object} config - Configuration object
     * @param {string} questionId - The question ID
     * @param {Array} subQuestionIds - Array of sub question IDs
     * @param {Object} addonData - Object containing addons, addonsQty, and businessRulesAddons
     * @param {string} type - The type of update
     * @returns {Object} Updated addon data
     */
    static removeSubQuestions(config, questionId, subQuestionIds, addonData, type) {
        let { addons, addonsQty, businessRulesAddons } = addonData;
        const questionPrefix = questionId.split('_')[0];

        Object.keys(config).forEach((key) => {
            const shouldRemoveRelatedSubQuestion = subQuestionIds?.includes(key) && key.startsWith(`${questionPrefix}_`) && questionId !== key;

            const shouldRemoveDirectSubQuestion = key.startsWith(`${questionId}_`);

            if (shouldRemoveRelatedSubQuestion || shouldRemoveDirectSubQuestion) {
                const previousAnswerSubQuestion = config[key];

                if (previousAnswerSubQuestion?.pid) {
                    // Handle special porting case
                    if (type === 'portingQty') {
                        const portingAddon = addons.find((addon) => addon.includes('number') && addon.includes('portin'));
                        if (portingAddon) {
                            ({ addons, addonsQty, businessRulesAddons } = ConfigurationManager.updateItemInAddons(portingAddon, 0, addons, addonsQty, businessRulesAddons));
                        }
                    }

                    ({ addons, addonsQty, businessRulesAddons } = ConfigurationManager.updateItemInAddons(
                        previousAnswerSubQuestion.pid,
                        0,
                        addons,
                        addonsQty,
                        businessRulesAddons
                    ));
                }

                delete config[key];
            }
        });

        return { addons, addonsQty, businessRulesAddons };
    }

    /**
     * Update URL, config input, and trigger events
     * @param {Object} config - Configuration object
     * @param {Array} addons - Array of addon IDs
     * @param {Array} addonsQty - Array of addon quantities
     * @param {Object} businessRulesAddons - Business rules addons object
     */
    finalizeConfigUpdate(config, addons, addonsQty, businessRulesAddons) {
        const finalConfig = JSON.stringify(config);

        // Update data attributes
        ConfigurationManager.setAddonDataAttributes(businessRulesAddons, addons, addonsQty);

        // Update configuration attributes
        ConfigurationManager.setActiveConfigAttribute(finalConfig);

        // Update config input
        this.configInput = document.querySelector('.js-active-configuration');
        this.configInput.value = finalConfig;

        // Update share button
        this.updateShareConfigurationUrl(finalConfig);

        // Update URL
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.delete('answers');
        params.set('answers', finalConfig);
        window.history.replaceState({}, '', `${url.pathname}?${params.toString()}`);

        // Trigger content update
        document.dispatchEvent(new CustomEvent('teamscalling:contentupdate'));
    }

    handleConfigUpdate(event) {
        const { type, subType, questionId, value, subQuestionIds, defaultSubQuestionAnswer } = event.detail;

        var businessRulesAddons = ConfigurationManager.getBusinessRulesAddons();
        var { addons, addonsQty } = ConfigurationManager.getAddons();
        const config = this.parseConfig();

        // Store previous answer for cleanup
        const previousAnswer = config[questionId];

        // Update or delete main question answer
        if (value === null) {
            delete config[questionId];
        } else {
            config[questionId] = value;
        }

        // Handle sub questions cleanup for radio types
        if (type === 'radio' || subType === 'radio') {
            ({ addons, addonsQty, businessRulesAddons } = ConfigurationManager.removeSubQuestions(
                config,
                questionId,
                subQuestionIds,
                { addons, addonsQty, businessRulesAddons },
                type
            ));
        }

        // Handle default sub question answer
        if (defaultSubQuestionAnswer?.questionId) {
            // Update config
            if (defaultSubQuestionAnswer.value === null) {
                delete config[defaultSubQuestionAnswer.questionId];
            } else {
                config[defaultSubQuestionAnswer.questionId] = defaultSubQuestionAnswer.value;
            }

            // Handle addon updates
            if (defaultSubQuestionAnswer.value?.pid) {
                const defaultPidToAdd = defaultSubQuestionAnswer.value.pid.split('_')[0];
                const index = addons.indexOf(defaultPidToAdd);

                if (index > -1) {
                    addons.splice(index, 1);
                    addonsQty.splice(index, 1);
                }

                const defaultValueQty = parseInt(defaultSubQuestionAnswer.value.qty, 10);

                addons.push(defaultPidToAdd);
                addonsQty.push(Number.isNaN(defaultValueQty) ? 1 : defaultValueQty);
            }
        }

        // Remove previous answer addons
        if (previousAnswer?.pid) {
            ({ addons, addonsQty, businessRulesAddons } = ConfigurationManager.updateItemInAddons(previousAnswer.pid, 0, addons, addonsQty, businessRulesAddons));
        }

        // Handle type-specific updates
        switch (type) {
            case 'variation':
                if (value?.pid) {
                    ConfigurationManager.setPidAttribute(value.pid);
                }
                break;

            case 'linesQty': {
                ConfigurationManager.setLinesQtyAttribute(value);

                // Update recurring addons and config
                const recurringAddons = [addons.find((addon) => addon.includes('worry-free')), addons.find((addon) => addon.includes('row-'))].filter(Boolean);

                const worryFreeConfigKey = Object.keys(config).find((key) => config[key].pid?.includes('worry-free'));
                const rowConfigKey = Object.keys(config).find((key) => config[key].pid?.includes('row-'));

                recurringAddons.forEach((pid) => {
                    ({ addons, addonsQty, businessRulesAddons } = ConfigurationManager.updateItemInAddons(pid, value, addons, addonsQty, businessRulesAddons));
                });

                if (worryFreeConfigKey && config[worryFreeConfigKey]) {
                    config[worryFreeConfigKey].qty = value;
                }

                if (rowConfigKey && config[rowConfigKey]) {
                    config[rowConfigKey].qty = value;
                }
                break;
            }

            case 'usersQty': {
                ConfigurationManager.setUsersQtyAttribute(value);

                // Remove porting addons and config
                const numbersAddons = [
                    addons.find((addon) => addon.includes('number') && addon.includes('new')),
                    addons.find((addon) => addon.includes('number') && addon.includes('portin'))
                ].filter(Boolean);

                const portingConfigKey = Object.keys(config).find((key) => config[key].pid?.includes('number') && config[key].pid?.includes('new'));

                numbersAddons.forEach((pid) => {
                    ({ addons, addonsQty, businessRulesAddons } = ConfigurationManager.updateItemInAddons(pid, 0, addons, addonsQty, businessRulesAddons));
                });

                if (portingConfigKey && config[portingConfigKey]) {
                    delete config[portingConfigKey];
                }
                break;
            }

            case 'businessRulesAddon':
                if (value?.pid) {
                    businessRulesAddons[value.pid] = { qty: value.quantity || 1 };
                }
                break;

            default:
                if (value?.pid) {
                    const pidToAdd = value.pid.split('_')[0];
                    const index = addons.indexOf(pidToAdd);

                    if (index > -1) {
                        addons.splice(index, 1);
                        addonsQty.splice(index, 1);
                    }

                    const valueQty = parseInt(value.qty, 10);
                    addons.push(pidToAdd);
                    addonsQty.push(Number.isNaN(valueQty) ? 1 : valueQty);
                }
                break;
        }

        // Finalize the update
        this.finalizeConfigUpdate(config, addons, addonsQty, businessRulesAddons);
    }

    destroy() {
        document.removeEventListener('teamscalling:configupdate', this.handleConfigUpdate);
    }
}

// Create and export the instance
let configManagerInstance = null;

// Initialize if config input exists
const configInput = document.querySelector('.js-active-configuration');
if (configInput) {
    configManagerInstance = new ConfigurationManager(configInput);
}

export default configManagerInstance;
